import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import theme from './theme/theme';
import customerTheme from './theme/customerTheme';
import PublicLayout from './components/PublicLayout';
import CustomerLayout from './components/CustomerLayout';
import ProtectedRoute from './components/ProtectedRoute';

// Public Pages
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Products from './pages/Products';
import ServiceCatalog from './pages/ServiceCatalog';
import HowItWorks from './pages/HowItWorks';
import Testimonials from './pages/Testimonials';
import Contact from './pages/Contact';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import AccountDeletion from './pages/AccountDeletion';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';

// New Feature Pages
import Offers from './pages/Offers';
import GiftCertificate from './pages/GiftCertificate';
import Affiliate from './pages/Affiliate';

// Customer Pages
import CustomerHome from './pages/Dashboard';
import Profile from './pages/Profile';
import Orders from './pages/Orders';
import OrderTracking from './pages/OrderTracking';
import Wishlist from './pages/Wishlist';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Wallet from './pages/Wallet';
import Chat from './pages/Chat';
import Settings from './pages/Settings';
import Notifications from './pages/Notifications';
import Membership from './pages/Membership';
import ProductDetail from './pages/ProductDetail';
import CustomerProducts from './pages/CustomerProducts';
import CustomerProductDetail from './pages/CustomerProductDetail';
import ProviderProfile from './pages/ProviderProfile';

// NEW Customer Pages (14 missing features)
import Referral from './pages/Referral';
import CustomerRewards from './pages/CustomerRewards';
import AddressManagement from './pages/AddressManagement';
import PaymentMethods from './pages/PaymentMethods';
import CustomerReviews from './pages/CustomerReviews';
import Bookings from './pages/Bookings';
import ServiceDetail from './pages/ServiceDetail';
import CategoryDetail from './pages/CategoryDetail';
import QrPayment from './pages/QrPayment';
import TwoFactorAuth from './pages/TwoFactorAuth';
import HelpSupport from './pages/HelpSupport';
import Coupons from './pages/Coupons';
import DeliveryTracking from './pages/DeliveryTracking';
import OrderSuccess from './pages/OrderSuccess';

import NotFound from './pages/NotFound';

function App() {
  return (
    <ConfigProvider theme={theme}>
      <Routes>
        {/* Auth (standalone, no site header/footer) */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Login />} />

        {/* Public routes */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:id" element={<ProductDetail />} />
          <Route path="/provider/:id" element={<ProviderProfile />} />
          <Route path="/service-catalog" element={<ServiceCatalog />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/account-deletion" element={<AccountDeletion />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/offers" element={<Offers />} />
        </Route>

        {/* Customer authenticated routes */}
        <Route
          element={
            <ProtectedRoute>
              <ConfigProvider theme={customerTheme}>
                <CustomerLayout />
              </ConfigProvider>
            </ProtectedRoute>
          }
        >
          <Route path="/dashboard" element={<CustomerHome />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/tracking/:orderId" element={<OrderTracking />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/wallet" element={<Wallet />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/membership" element={<Membership />} />
          <Route path="/gift-certificates" element={<GiftCertificate />} />
          <Route path="/affiliate" element={<Affiliate />} />
          <Route path="/customer/products" element={<CustomerProducts />} />
          <Route path="/customer/products/:id" element={<CustomerProductDetail />} />

          {/* NEW Routes */}
          <Route path="/referral" element={<Referral />} />
          <Route path="/rewards" element={<CustomerRewards />} />
          <Route path="/addresses" element={<AddressManagement />} />
          <Route path="/payment-methods" element={<PaymentMethods />} />
          <Route path="/my-reviews" element={<CustomerReviews />} />
          <Route path="/bookings" element={<Bookings />} />
          <Route path="/services/:id" element={<ServiceDetail />} />
          <Route path="/categories/:id" element={<CategoryDetail />} />
          <Route path="/qr-payment" element={<QrPayment />} />
          <Route path="/two-factor-auth" element={<TwoFactorAuth />} />
          <Route path="/help-support" element={<HelpSupport />} />
          <Route path="/coupons" element={<Coupons />} />
          <Route path="/delivery-tracking/:orderId" element={<DeliveryTracking />} />
          <Route path="/order-success" element={<OrderSuccess />} />
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </ConfigProvider>
  );
}

export default App;
